// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getClinicPatientStatistics } from "../../api";
import { ClinicPatientStatsType } from "../../types";

export const useClinicPatientStats = (
  clinicId: string | undefined,
  payload: { recentFilterDate: string }
) => {
  const { getToken } = useTokenAccess();

  return useQuery<ClinicPatientStatsType>({
    queryKey: ["clinic-patient-stats", clinicId, payload],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      const controller = new AbortController();
      return getClinicPatientStatistics(
        token,
        clinicId,
        payload,
        controller.signal
      );
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
